import { render } from "./NotFound.vue?vue&type=template&id=1eb99a28&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=1eb99a28&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1eb99a28"

export default script